export default __webpack_public_path__ + "static/motuGreen3-ae7440b69ffa0ba7e4f93d3e80bdbf3c.jpg";